import { Observer, observer } from 'mobx-react-lite'
import { DateField, type DateFieldProps } from '@/components/inputs/DateField'
import type { FilterProps } from '@/infra/type-utils'
import {
  type ContainerProps,
  FormFieldContainer,
} from '@/components/FormContainer'
import { action } from 'mobx'

/**
 * Form field container for a {@link DateField}.
 */
export const DateFieldContainer = observer(function DateFieldContainer<
  M extends object,
  K extends keyof FilterProps<M, Date | null>,
>({
  name,
  model,
  label,
  hint,
  field,
  error,
  hintTestId,
  'aria-label': ariaLabel,
  ...rest
}: ContainerProps<M, Date | null, K, Omit<DateFieldProps, 'value'>>) {
  return (
    <FormFieldContainer
      name={name}
      model={model}
      label={label}
      hint={hint}
      field={field}
      error={error}
      aria-label={ariaLabel}
      hintTestId={hintTestId}
      render={(controlProps) => (
        // Using `Observer` here makes it so only the `DateField`
        // re-renders when the value changes.
        <Observer>
          {() => (
            <DateField
              {...controlProps}
              value={model[field] as Date | null}
              onChange={action((newValue) => (model[field] = newValue as M[K]))}
              {...rest}
            />
          )}
        </Observer>
      )}
    />
  )
})
